import { render, staticRenderFns } from "./IbCheckmark.vue?vue&type=template&id=79adcac0&scoped=true"
import script from "./IbCheckmark.vue?vue&type=script&lang=js"
export * from "./IbCheckmark.vue?vue&type=script&lang=js"
import style0 from "./IbCheckmark.vue?vue&type=style&index=0&id=79adcac0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79adcac0",
  null
  
)

export default component.exports